export const reviewGettingStartedText = {
    employeeIdLabel: {
        english: 'Employee ID',
        spanish: 'ID de empleado',
    },
    ssnLabel: {
        english: 'SSN',
        spanish: 'SSN',
    },
    ssnEndingText: {
        english: 'ending in',
        spanish: 'que termina en',
    },
    reviewGettingStartSubHeading: {
        english: 'Identity verification',
        spanish: 'Verificación de identidad',
    },
};
